export const CATEGORY_PRODUCT_LIMIT = 28;
export const CATEGORY_LENSES_ID = 174;
export const NEUTRAL_CATEGORY_ID = 3;
export const HTO_CODE_FILTER = 'eligible_for_hto';
export const PRODUCT_BADGE_CODE_FILTER = 'product_badge';
export const CLEARANCE_PRODUCT_BADGE_FILTER = 'clearance';
export const HTO_FILTER_ENABLING_ID = 1;
export const SKIPPED_FILTERS = [HTO_CODE_FILTER];
export const CATEGORY_STORE = 'category';
export const RECENTLY_VIEWED_STORE = 'recentlyViewed';
export const HP_FEATURED_STORE = 'hpFeaturedStore';
export const HP_SHOP_THE_LOOK_STORE = 'hpShopTheLookStore';

export const CATEGORIES = {
    'womens-eyeglasses': 103,
    'mens-eyeglasses': 104,
    'kids-glasses': 159,
    'progressive-lenses': 18,
    'eyeglasses-collection': 5,
    sunglasses: 201,
    'mens-sunglasses': 177,
    'womens-sunglasses': 176,
    'polarized-sunglasses': 285,
    'ray-ban-sunglasses': 282,
    'oakley-sunglasses': 281,
    'prescription-sunglasses': 13,
    'eyes-of-faith': 121,
    'designer-glasses': 71,
    'contact-lenses': 174,
    'discounted-eyeglasses': 31,
    'ray-ban': 136,
    'persol-eyewear': 189,
    'oakley-glasses': 147,
    'muse-eyewear': 120,
    'coach-eyewear': 180,
    'gucci-eyewear': 187,
    'dkny-eyewear': 142,
    'michael-kors-eyewear': 145,
    'prada-eyewear': 193,
    'best-sellers': 97,
    hilaryduff: 203,
    'sports-glasses': 119,
    'computer-glasses': 164,
    'versace-eyewear': 182,
    'costa-del-mar-sunglasses': 253,
    ottoto: 165,
    'champion-glasses': 314,
};

export const CATEGORY_URL_LIST_FOR_FILTERS = [
    '/eyeglasses-collection',
    '/sunglasses',
    '/discounted-eyeglasses',
];

export const CATEGORY_FILTER_COLOR = 'color';
